"use client";

import { useEffect } from "react";
import { pixelTrack } from "./MetaPixelTracker";

export default function ViewContentTracker({
  contentName,
  contentCategory,
}: {
  contentName: string;
  contentCategory: string;
}) {
  useEffect(() => {
    pixelTrack("ViewContent", { content_name: contentName, content_category: contentCategory });
  }, [contentName, contentCategory]);

  return null;
}
